// extracted by mini-css-extract-plugin
export default {"button":"ReloadButton__button--32JuC","buttonMobile":"ReloadButton__buttonMobile--1DTC3"};